// Mock data for Marqi website
export const mockData = {
  // Hero Section
  hero: {
    title: "Three Services. One Partner. Your Agency, Everywhere.",
    subtitle: "Marqi gives SMB agencies a complete white-label growth partner — outsourced ad operations, CTV advertising for your clients, and AI search visibility — under your brand, without adding headcount.",
    cta: "Book a Strategy Session",
    videoCta: ""
  },

  // Services Overview
  services: [
    {
      id: 1,
      title: "Marqi Ops",
      accent: "lime",
      description: "Your outsourced ad operations team. Campaigns trafficked, optimised, and reported — under your brand.",
      features: ["White-label campaign management", "48-hour setup, no onboarding delays", "Google, Meta, Amazon, TikTok and more", "Scales with your client roster"],
      cta: "Explore Marqi Ops",
      href: "/ops"
    },
    {
      id: 2,
      title: "MarqiCast",
      accent: "lime",
      description: "Offer connected TV advertising to your SMB clients. AI creative, premium inventory, proof of ROI.",
      features: ["AI-generated broadcast-ready spots", "Disney+, Hulu, Peacock and more", "Hyperlocal targeting to 1-mile radius", "Foot traffic & website attribution"],
      cta: "Discover MarqiCast",
      href: "/cast"
    },
    {
      id: 3,
      title: "MarqiRank",
      accent: "purple",
      description: "Make your clients visible in ChatGPT, Gemini, and Perplexity — and prove it with AI Share of Voice.",
      features: ["Generative Engine Optimisation (GEO)", "Answer Engine Optimisation (AEO)", "ChatGPT Ads management", "AI citation tracking & monthly report"],
      cta: "Explore MarqiRank",
      href: "/rank"
    }
  ],

  // Industries
  industries: [
    {
      id: 1,
      name: "Direct-to-Consumer",
      description: "Specialized strategies for D2C brands focusing on customer acquisition and lifetime value optimization.",
      stats: { clients: "150+", growth: "340%", roas: "4.2x" }
    },
    {
      id: 2,
      name: "Law Firms",
      description: "Compliance-focused advertising solutions for legal practices with proven lead generation strategies.",
      stats: { clients: "80+", growth: "280%", cpl: "-45%" }
    }
  ],

  // Case Studies - Current Agency & Ops results
  caseStudies: [
    {
      id: 1,
      title: "D2C Beauty Brand Scales to 7-Figure Revenue",
      industry: "Beauty & Cosmetics",
      challenge: "High CAC and inefficient ad spend across multiple channels with previous agency",
      solution: "Implemented unified attribution model with strategic budget allocation across platforms",
      results: {
        revenue: "+350%",
        roas: "4.8x",
        cac: "-30%"
      },
      duration: "8 months"
    },
    {
      id: 2,
      title: "Personal Injury Law Firm Dominates Local Market",
      industry: "Legal Services", 
      challenge: "Low-quality leads and high cost per acquisition from generic campaigns",
      solution: "Developed compliance-focused, geo-targeted campaigns with advanced tracking",
      results: {
        leads: "+180%",
        quality: "+45%",
        cpl: "-25%"
      },
      duration: "6 months"
    }
  ],

  // Team Members
  team: [
    {
      id: 1,
      name: "Sarah Chen",
      role: "CEO & Founder",
      bio: "Former Google Ads executive with 12+ years in programmatic advertising and team leadership.",
      image: "https://images.unsplash.com/photo-1494790108755-2616b612b1c5?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 2,
      name: "Marcus Rodriguez",
      role: "Head of Operations",
      bio: "Performance marketing specialist with expertise in scaling operations for high-growth agencies.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    },
    {
      id: 3,
      name: "Dr. Emily Watson",
      role: "Head of AI",
      bio: "PhD in Machine Learning with previous roles at Meta and Amazon developing advertising algorithms.",
      image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80"
    }
  ],

  // Blog Posts - Empty until real articles are added
  blogPosts: [],

  // Pricing Tiers (for Ops)
  pricingTiers: [
    {
      id: 1,
      name: "Starter Pod",
      price: "$3,500",
      period: "month",
      description: "Agencies managing up to $50K monthly client ad spend",
      features: [
        "1 dedicated operations specialist",
        "Campaign setup & trafficking",
        "Weekly white-label performance reports",
        "Email support",
        "Basic analytics dashboard",
        "White-label delivery included"
      ],
      popular: false
    },
    {
      id: 2,
      name: "Growth Pod",
      price: "$7,500",
      period: "month",
      description: "Agencies managing $50K–$200K monthly client ad spend",
      features: [
        "Senior ops team (2–3 specialists)",
        "Advanced campaign optimisation",
        "Daily performance monitoring",
        "Custom white-label dashboards",
        "Priority Slack support",
        "White-label client reporting",
        "Competitive & predictive analysis"
      ],
      popular: true
    },
    {
      id: 3,
      name: "Enterprise Pod",
      price: "Custom",
      period: "pricing",
      description: "Agencies managing $200K+ monthly client ad spend",
      features: [
        "Dedicated ops team (4+ specialists)",
        "Full white-label solutions",
        "Creative ops (production & management)",
        "AI-assisted optimisation workflows",
        "24/7 support & monitoring",
        "Custom integrations & workflows",
        "Dedicated account manager"
      ],
      popular: false
    }
  ],

  // AI Products
  aiProducts: [
    {
      id: 1,
      name: "Budget Optimizer",
      description: "AI-powered budget allocation across channels and campaigns for maximum ROI",
      benefits: ["30% improvement in ROAS", "Automated reallocation", "Real-time optimization"],
      status: "Development"
    },
    {
      id: 2,
      name: "Anomaly Detector",
      description: "Intelligent monitoring system that identifies performance anomalies and recommends actions",
      benefits: ["99.5% uptime monitoring", "Instant alerts", "Predictive insights"],
      status: "Development"
    },
    {
      id: 3,
      name: "Creative Intelligence",
      description: "AI analysis of creative performance with automated A/B testing recommendations",
      benefits: ["45% faster creative iteration", "Performance prediction", "Automated insights"],
      status: "Coming Soon"
    },
    {
      id: 4,
      name: "Campaign Optimizer",
      description: "Machine learning algorithms that continuously optimize campaign settings and targeting",
      benefits: ["24/7 optimization", "Multi-variable testing", "Performance learning"],
      status: "Coming Soon"
    }
  ],

  // Statistics - Four Pillars
  stats: {
    experience: "30+ Years Experience",
    specialists: "Certified Specialists", 
    aiPrecision: "AI-Powered Precision",
    oversight: "Expert Oversight"
  },

  // Testimonials - Current clients of Agency & Ops services
  testimonials: [
    {
      id: 1,
      quote: "Marqi's Ops team transformed our media buying efficiency. Their white-label specialists helped us scale from $100K to $500K monthly ad spend while improving our ROAS by 40%. MarqiCast opened up connected TV for our clients too.",
      author: "Jennifer Walsh",
      title: "CMO",
      company: "Leading D2C Beauty Brand"
    },
    {
      id: 2,
      quote: "The Ops team at Marqi became an extension of our agency. Their expertise in programmatic and retail media opened new revenue streams we never thought possible. The quality is exceptional.",
      author: "David Park", 
      title: "Founder & CEO",
      company: "Growth Marketing Agency"
    },
    {
      id: 3,
      quote: "Working with Marqi's legal advertising specialists increased our qualified leads by 280% while maintaining full compliance. Game changer for our practice.",
      author: "Robert Martinez",
      title: "Managing Partner",
      company: "Personal Injury Law Firm"
    }
  ]
};

export default mockData;